import apiClient from './apiClient';
import {
  CURRENT_INTEREST_BANK_VERSION,
  INTEREST_VECTOR_LENGTH,
  isScoreableInterestVectorLength
} from '../config/productVectors';

export { INTEREST_VECTOR_LENGTH };

/**
 * Whether the user has a completed interest vector for the current bank.
 * @param {unknown} interestVector
 * @param {unknown} interestBankVersion
 * @returns {boolean}
 */
export function hasInterestVector(interestVector, interestBankVersion) {
  return (
    Array.isArray(interestVector) &&
    isScoreableInterestVectorLength(interestVector.length) &&
    interestBankVersion === CURRENT_INTEREST_BANK_VERSION
  );
}

/**
 * Load the current user's interest_vector and bank version from their profile.
 * @returns {Promise<{ interestVector: Array, interestBankVersion: string | null }>}
 */
export async function fetchUserInterestVector() {
  if (!localStorage.getItem('token')) {
    return { interestVector: [], interestBankVersion: null };
  }
  try {
    const res = await apiClient.get('/api/auth/me');
    if (!res.ok) return { interestVector: [], interestBankVersion: null };
    const profile = await res.json().catch(() => null);
    return {
      interestVector: Array.isArray(profile?.interest_vector) ? profile.interest_vector : [],
      interestBankVersion: profile?.interest_bank_version ?? null
    };
  } catch {
    return { interestVector: [], interestBankVersion: null };
  }
}

/**
 * Fetch profile vector and report whether it is complete for the current bank.
 * @returns {Promise<{ interestVector: Array, interestBankVersion: string | null, hasInterestVector: boolean }>}
 */
export async function loadUserInterestVectorState() {
  const { interestVector, interestBankVersion } = await fetchUserInterestVector();
  return {
    interestVector,
    interestBankVersion,
    hasInterestVector: hasInterestVector(interestVector, interestBankVersion)
  };
}
